import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthNoticeService } from '../../services/auth-notice.service';
import { NgForm } from '@angular/forms';
import * as objectPath from 'object-path';
import { TranslateService } from '@ngx-translate/core';
// import { SpinnerButtonOptions } from '../../../partials/content/general/spinner-button/button-options.interface';

import { Store } from '@ngrx/store';
import * as AuthActions from '../../actions/auth';
import * as fromAuth from '../../reducers';
import { Actions, ofType } from '@ngrx/effects';

@Component({
  selector: 'quantum-login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPage implements OnInit, AfterViewInit, OnDestroy {
  public model: any = { userName: '', password: '', channelType: '_SYS_LT_B' };
  public loading = false;

  @ViewChild('f') f: NgForm;
  errors: any[] = [];

  actionsSub: Subscription;

  constructor(
    public authNoticeService: AuthNoticeService,
    private translate: TranslateService,
    private store: Store<fromAuth.State>,
    private actions$: Actions,
  ) {
    this.actionsSub = this.actions$.pipe(
      ofType(AuthActions.LoginFailure)
    ).subscribe(() => {
      this.loading = false;
      this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'error');
    });
  }

  submit() {
    if (this.validate(this.f)) {
      this.loading = true;
      this.store.dispatch(AuthActions.Login({ credential: this.model }));
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // The QR host belongs to this routed view. Initializing it from window.onload
    // can run before Angular creates the login route (especially with APP_INITIALIZER).
    const wwLogin = (window as any).WwLogin;
    if (typeof wwLogin !== 'function' || !document.getElementById('login_container')) {
      return;
    }

    const domain = document.domain.toLowerCase();
    let appid = 'ww509a508c1034eebc';
    let agentid = '1000011';
    let redirectUri = 'https://aramark-dev.usequantum.com.cn/auth.php';

    if (domain.indexOf('dev') === -1) {
      if (domain.indexOf('alpha') !== -1) {
        agentid = '1000010';
        redirectUri = 'https://aramark-alpha.usequantum.com.cn/phpwechat/example/auth.php';
      } else if (domain.indexOf('ehs.aramark') !== -1) {
        appid = 'ww938b0c3339aa039e';
        agentid = '1000019';
        redirectUri = 'https://ehs.aramark.cn/auth.php';
      }
    }

    wwLogin({
      id: 'login_container',
      appid,
      agentid,
      state: '',
      redirect_uri: encodeURIComponent(redirectUri),
      href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9'
    });
  }

  ngOnDestroy(): void {
    this.authNoticeService.setNotice(null);
    this.actionsSub.unsubscribe();
  }

  validate(f: NgForm) {
    if (f.form.status === 'VALID') {
      return true;
    }

    this.errors = [];

    if (objectPath.get(f, 'form.controls.userName.errors.required')) {
      this.errors.push(this.translate.instant('AUTH.VALIDATION.REQUIRED', { name: this.translate.instant('AUTH.INPUT.USER_NAME')}));
    }
    if (objectPath.get(f, 'form.controls.password.errors.required')) {
      this.errors.push(this.translate.instant('AUTH.VALIDATION.REQUIRED', {name: this.translate.instant('AUTH.INPUT.PASSWORD')}));
    }
    if (objectPath.get(f, 'form.controls.password.errors.minlength')) {
      this.errors.push(this.translate.instant('AUTH.VALIDATION.MIN_LENGTH', {name: this.translate.instant('AUTH.INPUT.PASSWORD'), min: 4}));
    }

    if (this.errors.length > 0) {
      this.authNoticeService.setNotice(this.errors.join('<br/>'), 'error');
    }

    return false;
  }
}
